import { API_ERROR_CODES, apiGetOneTimeToken, ONBOARDING_API_BASE_URL } from './index.ts';

/**
 * Verify OTP code using session from previous authentication
 */

export type ApiOtpVerifyResult = {
  data?: {
    requiresSetPassword?: boolean;
    oneTimeToken?: string;
    connectApplicationId?: string;
    identityId?: string;
    owner?: string;
    userId?: string;
    p_id?: string;
  };
  errorCode?: API_ERROR_CODES;
  errorMessage?: string;
};

export const apiOtpVerify = async (otp: string, csrfToken: string, jid: string | null): Promise<ApiOtpVerifyResult> => {
  return fetch(`${ONBOARDING_API_BASE_URL}/auth/otp/verify`, {
    method: 'POST',
    body: JSON.stringify({
      otp: `${otp.substring(0, 3)}-${otp.substring(3)}`,
      jid,
    }),
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-CSRF-Token': csrfToken,
    },
  })
    .then(async (response) => {
      if (!response.ok) {
        const errorMessage = await response.text();
        return {
          errorCode: API_ERROR_CODES.GENERIC,
          errorMessage,
        };
      }

      const responseJson = await response.json();

      // if the server tells us requiresSetPassword = false then this is the last step
      // so we can fetch the one time token now
      let oneTimeToken = undefined;
      let tokenData = undefined;
      if (!responseJson.requiresSetPassword) {
        const { data: oneTimeTokenData, errorCode, errorMessage } = await apiGetOneTimeToken(csrfToken);
        if (oneTimeTokenData) {
          oneTimeToken = oneTimeTokenData.oneTimeToken;
          tokenData = oneTimeTokenData;
        } else if (errorCode) {
          return {
            errorCode,
            errorMessage,
          };
        }
      }

      return {
        data: {
          ...responseJson,
          oneTimeToken,
          identityId:
            responseJson.identityId ||
            responseJson.owner ||
            responseJson.userId ||
            tokenData?.identityId ||
            tokenData?.owner ||
            tokenData?.userId,
        },
      } as ApiOtpVerifyResult;
    })
    .catch(() => ({
      errorCode: API_ERROR_CODES.GENERIC,
    }));
};
